import { render, staticRenderFns } from "./ClientEditPage.vue?vue&type=template&id=299ab176&scoped=true&"
import script from "./ClientEditPage.vue?vue&type=script&lang=ts&"
export * from "./ClientEditPage.vue?vue&type=script&lang=ts&"
import style0 from "./ClientEditPage.vue?vue&type=style&index=0&id=299ab176&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299ab176",
  null
  
)

export default component.exports